import Link from "next/link";
import Categories from "../../types/Categories";
import styles from "./styles.module.scss";
import { ItemsExpansives } from "../../types/ExpansiveItems";
import { Expansives } from "./itemsExpansives";
import AdBanner from "../AdsBanner";

interface SidebarItems {
  categoriesBlock: Array<Categories>;
  expansorPosts: Array<ItemsExpansives>;
  expansorPages: Array<ItemsExpansives>;
  adSenseId?: string;
}

export const Sidebar = ({
  categoriesBlock,
  expansorPosts,
  expansorPages,
  adSenseId,
}: SidebarItems) => {
  return (
    <div className={styles.containerCat}>
      <p>Navegue por:</p>
      {categoriesBlock.length > 0 &&
        categoriesBlock.map((item) => {
          return (
            <span key={item.name}>
              <Link href={item.link} passHref className={styles.items}>
                {item.name}
              </Link>
            </span>
          );
        })}

      <Expansives title={"Últimos Posts"} expansor={expansorPosts} />

      <Expansives title={"Páginas"} expansor={expansorPages} />

      {adSenseId && (
        <AdBanner
          data-ad-slot={adSenseId}
          data-ad-format="vertical"
          data-full-width-responsive="true"
        />
      )}
    </div>
  );
};
